module.exports = __webpack_public_path__ + "img/logo-loacker.c944408e.svg";